import { useEffect, useState } from "react";

// DESIGN.md "Mozgás": the curve draws itself once, in --emc-draw-duration.
// The duration is read from the token rather than written here, and the
// token is 0s under prefers-reduced-motion (tokens.css), so a reader who
// asked for less motion gets a curve that is simply there.

function readDrawDuration(): number {
  if (typeof window === "undefined") return 0;
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue("--emc-draw-duration")
    .trim();
  const value = Number.parseFloat(raw);
  if (!Number.isFinite(value)) return 0;
  return raw.endsWith("ms") ? value : value * 1000;
}

/** The curve's draw time in milliseconds; 0 means "do not animate". */
export function useDrawDuration(): number {
  const [duration, setDuration] = useState(readDrawDuration);
  useEffect(() => {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setDuration(readDrawDuration());
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);
  return duration;
}
